import React from 'react';
import SignIn from '../EmailAndPassword/SignIn';
import Facebook from '../Facebook/Facebook';
import Google from '../Google/Google';

const LogIn = () => {
    return (
        <div style={{marginTop:'60px',color:'black'}}>
            <div className="d-flex justify-content-center mb-5">
                <SignIn />
            </div>
            <div className="d-flex justify-content-center">
                <Google />
            </div>
            <br/>
            <div className="d-flex justify-content-center">
                <Facebook />
            </div>
        </div>
    );
};

export default LogIn;